<template>
  <div
    class="field-item field-textarea"
    :class="[!!modelValue && isValid ? 'isValid' : '']"
  >
    <div class="field-label">
      {{ label }}
      <div
        class="optional"
        v-if="!required"
      >
        (optional)
      </div>
    </div>
    <div class="field-wrap">
      <textarea
        class="field-input"
        :value="modelValue"
        @input="onInput"
        :placeholder="placeholder"
        required="required"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
}

const props = defineProps({
  label: {
    default: null,
  },
  modelValue: {
    default: null,
  },
  placeholder: {
    default: null,
  },
  required: {
    default: false,
  },
  valid: {
    default: false,
  },
})
const emits = defineEmits(["update:modelValue", "update:valid"])

const isValid = computed(() => {
  if (!props.modelValue) return false
  switch (props.type) {
    case "email":
      if (!validateEmail(props.modelValue)) return false
      break
  }
  return true
})

const onInput = async function (evt) {
  let value = evt.target.value
  emits("update:modelValue", value)
}

watchEffect(() => {
  emits("update:valid", isValid.value)
})

defineExpose({
  isValid,
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
@import "./form.scss";
</style>
